module.exports = __webpack_public_path__ + "static/img/Dog-2.869391aa.png";